/* eslint-disable no-console */
export default function handleAnchorClick (event) {
  event.preventDefault()

  const url = event.target.getAttribute('data-href')
  const baseUrl = window.location.href

  console.log('url', url)

  if (url.includes('#')) {
    const hash = url.substring(url.indexOf('#'))

    if (baseUrl.substring(0, url.indexOf('#')) === url.substring(0, url.indexOf('#'))) {
      // Do smooth scroll to section
      document.querySelector(hash).scrollIntoView({
        behavior: 'smooth'
      })
    } else {
      // Redirect to different base URL with hash
      window.location = url
    }
  } else {
    // Redirect to different base URL without hash
    window.location = url
  }
}
